import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { FileWarning } from "lucide-react";

export function AlertaDocumentos() {
  const [res, setRes] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const load = useCallback(() => api.get("/alertas/documentos").then((r) => setRes(r.data)).catch(() => setRes(null)), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 120000);
    window.addEventListener("docs-alertas", load);
    return () => { clearInterval(t); window.removeEventListener("docs-alertas", load); };
  }, [load]);
  if (!res) return null;
  return (
    <div className="relative">
      <button onClick={() => { setOpen(!open); load(); }} data-testid="alerta-docs-btn" title="Documentos corregidos por revisar"
        className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold shadow-sm transition-transform hover:scale-[1.03] ${res.total ? "bg-sky-50 text-sky-700" : "bg-emerald-50 text-emerald-700"}`}>
        <FileWarning className="h-4 w-4" /> <span className="hidden 2xl:inline">Documentos corregidos</span>
        <span className="rounded-full bg-white/90 px-2 text-slate-900" data-testid="alerta-docs-total">{res.total}</span>
      </button>
      {open && (
        <div className="fixed left-2 right-2 top-16 z-40 rounded-xl border border-slate-200 bg-white p-3 shadow-xl sm:absolute sm:left-auto sm:right-0 sm:top-auto sm:mt-2 sm:w-80" data-testid="alerta-docs-panel">
          <p className="mb-2 text-sm font-semibold text-slate-800">Documentos cargados nuevamente por revisar</p>
          {res.items.length === 0 ? <p className="text-xs text-slate-500">No hay documentos corregidos pendientes.</p> : (
            <div className="max-h-80 divide-y divide-slate-100 overflow-y-auto">
              {res.items.map((i) => (
                <button key={i.id} onClick={() => { setOpen(false); navigate(`/expedientes?abrir=${i.expediente_id}`); }} data-testid={`alerta-docs-item-${i.id}`}
                  className="flex w-full flex-col py-2 text-left hover:bg-slate-50">
                  <span className="truncate text-sm font-medium text-slate-800">{i.nombre}</span>
                  <span className="text-xs text-slate-400">{i.categoria} · versión {i.version} · {new Date(i.fecha).toLocaleString("es-CO", { dateStyle: "short", timeStyle: "short" })}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
